<template>
  <div @mouseleave="hoverboxHide">
    <div class="container">
      <ul class="header-tabs-ul" mode="horizontal">
        <li class="my_text_center header-tabs-li" v-for="(item,i) in headerTabs" :key="i" @mouseenter="hoverboxShow(i)" @click="clickItemFuc(i)" :class="{active:item.status}">
          <router-link :to="item.url" class="header-tabs-li-text">{{item.text}}</router-link>
        </li>
        <li class="my_text_center header-tabs-li" style="position:relative">
          <a href="http://8q9p.cn" target="_blank"><span style="color:red">体验游戏</span></a>
          <img style="position:absolute;top:-15px;right:10px" src="static/imgs/hot/hot.gif"/>
        </li>        
      </ul>
    </div>
  </div>
</template>
<script>
import TabsHoverSection from "../components/TabsHoverSection";
import {mapState} from 'vuex'
export default {
  props: {
    headerTabs: {
      type: Array
    }
  },
  components: {
    TabsHoverSection
  },
  data() {
    return {
      isShowHoverBox: false,
      receiveLotteryIDVar: null,
      tabsIndex: null,
      isClickItem: false
    };
  },
  computed: {
    ...mapState("user", ["profile"])
  },    
  mounted() {
    this.watchHb()   
  },  
  methods: {
    hoverboxShow(i) {
      if (i == 1 || i == 2 || i == 3 || i == 4) {
        this.isShowHoverBox = false;
        this.tabsIndex = i;
      } else {
        this.isShowHoverBox = false;
      }
    },
    hoverboxHide() {
      this.isShowHoverBox = false;
    },
    clickItemFuc(i) {
      this.headerTabs.forEach((el, j) => {
        if (i == j) {
          el.status = 1;
        } else {
          el.status = 0;
        }
      });
    },
    watchHb(){
      this.$eventBus.$on('gotoUrl', (e) => {
        this.clickItemFuc(2)
      })
    }
  }
};
</script>







// WEBPACK FOOTER //
// src/components/HeaderTabs.vue